<script setup>
// Club-page cell for an Americano league (equivalent of MeetClickableCell):
// "Americano league · N members" from the americanos[] page-aggregate row.
import {computed} from 'vue';
import ClickableCell from '@/components/lists/ClickableCell';

const props = defineProps({
  americano: {
    type: Object,
    default: () => null
  }
});

const subtitle = computed(() => {
  const parts = ['Americano league'];
  if (props.americano.memberCount != null) parts.push(`${props.americano.memberCount} members`);
  else if (props.americano.playerCount != null) parts.push(`${props.americano.playerCount} members`);
  return parts.join(' · ');
});
</script>

<template>
  <clickable-cell
      icon="mdi-account-switch"
      tone="americano"
      class="mb-3"
      :to="{ name: 'AmericanoDetail', params: { americanoId: americano.id } }"
      :title="americano.name"
      :subtitle="subtitle"
  />
</template>
